import cn from 'classnames';

import Tooltip from 'components/common/Tooltip';
import FavoriteIcon from 'components/icons/FavoriteIcon';

const FavoriteIconTooltip = ({ ariaId, containerClassname, iconClassname }) => {
  return (
    <span className={cn('absolute right-4', containerClassname)}>
      <Tooltip
        ariaId={ariaId}
        triggerButtonContent={<FavoriteIcon className={iconClassname || 'h-8 w-8'} />}
      >
        <p>Saved to your favorites</p>
      </Tooltip>
    </span>
  );
};

FavoriteIconTooltip.propTypes = {
  ariaId: PropTypes.string,
  containerClassname: PropTypes.string,
  iconClassname: PropTypes.string,
};

export default FavoriteIconTooltip;
